import * as React from 'react';

import { IModerationInfo } from '../../models/agent';

import * as styles from './styles.css';

export interface IApprovalProps {
  moderationInfo?: IModerationInfo | null;
}

export const Approval = (props: IApprovalProps) => {
  const { moderationInfo } = props;
  const documentsNotVerified =
    !moderationInfo ||
    (!moderationInfo.userLevelInfo?.hasVerifiedDocuments && !moderationInfo.isUserIdentifiedByDocuments);

  if (documentsNotVerified) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div className={styles['icon']} />
      <div className={styles['content']}>Документы агента проверены</div>
    </div>
  );
};
